module.exports = __webpack_public_path__ + "img/logout.bc3510d0.svg";